/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import * as userActions from "../../redux/actions/userActions";
import ItemList from "./User-list-view";
import Form from "./User-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchForm from "./Search-form";

toast.configure({
  autoClose: 8000,
  draggable: false
});

class Users extends React.Component {
  componentDidMount() {
    const { actions, cActions } = this.props;
    actions.searchUsers(this.search);
  }

  componentDidUpdate(prevProps) {
    if (this.props.response !== prevProps.response) {
      const { actions, response, cActions } = this.props;
      if (response !== null) {
        this.myToast = toast.success(
          `${response.name} has been saved successfully`
        );
      }
      actions.searchUsers(this.search);
    }
  }

  constructor(props) {
    super(props);
    this.user = { username: "", password: "", email: "", name: "", role: [], phone: ""};
    this.state = {
      user: this.user
    };

    this.myToast = null;
    this.activePage = 0;
    this.search = {
      name: "",
      role: "",
      phone: "",
      page: this.activePage
    };
  }


  handleSearchChange = (event) => {
    const { value, name } = event.target;
    this.search[name] = value;
  };

  handleSearch = (event) => {
    const { actions } = this.props;
    actions.searchUsers(this.search);
  };

  handleChange = event => {
    const { value, name } = event.target;
    let currentUser = this.state.user;

    if (name === "attachments") {
      currentUser.attachments.append(value);
      console.log(event.target.value)
    } else if (name === "category") {
      currentUser = { ...this.state.user, [name]: { id: value } };
    } else if (name === "serviceProvider") {
      currentUser = { ...this.state.user, [name]: { id: value } };
    } else {
      currentUser = { ...this.state.user, [name]: value };
    }
    this.setState({ user: currentUser });
  };

  handleNewClick = (event, user) => {
    event.preventDefault();
  };

  handlePageClick = (pageNumber) => {
    this.activePage = pageNumber;
    this.search.page = pageNumber;
    const { actions } = this.props;
    actions.searchUsers(this.search);
  };

  handleSubmit = event => {
    event.preventDefault();
    const { actions } = this.props;
    this.user.username = this.user.phone;
    actions.createUser(this.user);
  };

  handleChildrenClick = user => {

  }

  render() {
    const {
      users = [],
      categories = [],
      isLoading = true,
      totalRecords,
      error = ""
    } = this.props;

    const {user} = this.state;

    if (error.length > 0) {
      this.myToast = toast.error(error);
    }

    return (
      <Fragment>
        <br/><br/>
        <div className="row">
          <div className="col-8">
            <SearchForm
              handleSubmit={this.handleSearch}
              handleChange={this.handleSearchChange}
            /><br/>
            <ItemList
              users={users}
              isLoading={isLoading}
              activePage={this.activePage} 
              totalItemsCount={totalRecords}
              handlePageClick={this.handlePageClick}
              handleChildrenClick={this.handleChildrenClick}
            />
          </div>
          <div className="col-4">
            <Form
              isLoading={isLoading}
              user={user}
              title="New User"
              handleNewClick={this.handleNewClick}
              handleSubmit={this.handleSubmit}
              handleChange={this.handleChange}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

Users.propTypes = {
  actions: PropTypes.object.isRequired,
  user: PropTypes.object,
  response: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  totalRecords: PropTypes.number.isRequired,
  categories: PropTypes.array.isRequired
};

function mapStateToProps(state) {
  return {
    users: state.users.users,
    categories: state.users.categories,
    error: state.users.error,
    isLoading: state.users.isLoading,
    showModal: state.users.showModal,
    user: state.users.user,
    totalRecords: state.users.totalRecords,
    response: state.users.response
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(userActions, dispatch)};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);
